export default __webpack_public_path__ + "static/media/prize-6-cn.ea4cd23a.webp";